import { put } from 'redux-saga/effects';
import LoaderActions from '@/store/ducks/loader';

export function* startLoaderRequest() {
  yield put(LoaderActions.startLoaderSuccess());
}

export function* stopLoaderRequest() {
  yield put(LoaderActions.stopLoaderSuccess());
}
